// Time and date manipulation functions

import moment from 'moment'

function endOfDayMoment() {
    return moment().endOf('day')
}

function startOfDayMoment() {
    return moment().startOf('day')
}

function formattedOrEmpty( item , format ) {
    if( item == null )
        return ""
    return moment(item).format(format)
}

function extractTime(dateString) {
    let date = new Date(Date.parse(dateString));
    return date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'});
}

function extractTimeMinutes(dateString) {
    if(!dateString) return null;
    const tPart = dateString.includes('T') ? dateString.split('T')[1] : dateString;
    const hhmm = tPart.slice(0, 5);
    const [h, m] = hhmm.split(':').map(x => parseInt(x, 10));
    if(isNaN(h) || isNaN(m)) return null;
    return h * 60 + m;
}

export default {
    endOfDayMoment,
    startOfDayMoment,
    formattedOrEmpty,
    extractTime,
    extractTimeMinutes
}